import { StarTable } from './shared/tables/StarTable'

export function TestPage() {
  const headerColumns = ['col1', 'col2', 'col3', 'col4']

  return <StarTable headerColumns={headerColumns} />
}
